import { combineReducers } from 'redux';
import authReducer from './auth.reducer';
import borrowerProfileReducer from './borrowerProfile.reducer';
import countriesReudcer from './country.reducer';
import loanReudcer from './loan.reducer';
import loanOfferReducer from './loanOffer.reducer';
import userProfileReducer from './userProfile.reducer';
import loanRepaymentReducer from './loanRepayment.reducer';
import transactionHistoryReducer from './transactionHistory.reducer';

const reducers = combineReducers({
  auth: authReducer,
  countries: countriesReudcer,
  borrowerProfile: borrowerProfileReducer,
  loan: loanReudcer,
  userProfile: userProfileReducer,
  loanOffer: loanOfferReducer,
  loanRepayment: loanRepaymentReducer,
  paginatedTransactionHistory: transactionHistoryReducer
});

export default reducers;

export type RootState = ReturnType<typeof reducers>;
